unit FunctionItemListType;
{

/* Initial. */

}

interface

uses
  FunctionItemType;

type
  TFunctionItemListType = array of TFunctionItemType;

implementation

end.
